// extracted by mini-css-extract-plugin
export default {"localeText":"styles_localeText__3Fr4e","localeSpan":"styles_localeSpan__WwyQt","error":"styles_error__EQ8RJ"};